  // Utilidad para mostrar nombre/apellidos si usuario es GUID
function mostrarNombreUsuario(usuarioId, usuarios) {
  if (!usuarioId) return '';
  // Si es un GUID, buscar en la lista
  if (/^[a-fA-F0-9]{24}$/.test(usuarioId)) {
    const u = usuarios?.find(u => u._id === usuarioId);
    if (u) return `${u.nombre} ${u.apellidos}`;
  }
  // Si no es GUID, mostrar tal cual
  return usuarioId;
}
// Utilidad para mostrar fecha en horario de España (Europe/Madrid)
function fechaMadrid(dateStr) {
  const utcDate = new Date(dateStr);
  // Obtener la fecha local de Madrid usando Intl.DateTimeFormat
  const madridFormatter = new Intl.DateTimeFormat('es-ES', {
    timeZone: 'Europe/Madrid',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
  // El formato es dd/mm/yyyy, hh:mm:ss
  return madridFormatter.format(utcDate);
}

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaEdit } from 'react-icons/fa';
import { API_BASE } from '../api';

function PanelModificacionFichajes({ token, usuario }) {
  const [fichajes, setFichajes] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [usuariosSeleccionados, setUsuariosSeleccionados] = useState([]);
  const [busquedaUsuario, setBusquedaUsuario] = useState('');
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');
  const [selected, setSelected] = useState(null);
  const [motivo, setMotivo] = useState('');
  const [nuevoTipo, setNuevoTipo] = useState('');
  const [nuevaFecha, setNuevaFecha] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Cargar usuarios para el filtro
  useEffect(() => {
    if (!usuario?.allowModify) return;
    const apiUrl = `${API_BASE}/api/auth/usuarios-basicos`;
    axios.get(apiUrl, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setUsuarios(res.data))
      .catch(() => setUsuarios([]));
  }, [token, usuario]);

  // Cargar fichajes filtrados
  const fetchFichajes = async () => {
    setLoading(true);
    setError('');
    try {
      let url = `${API_BASE}/api/fichaje/modificables`;
      const params = [];
      if (usuariosSeleccionados.length > 0) params.push('usuarios=' + usuariosSeleccionados.join(','));
      if (fechaDesde) params.push('desde=' + encodeURIComponent(fechaDesde));
      if (fechaHasta) params.push('hasta=' + encodeURIComponent(fechaHasta));
      if (params.length > 0) url += '?' + params.join('&');
      const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
      setFichajes(res.data);
    } catch {
      setError('Error cargando fichajes');
      setFichajes([]);
    }
    setLoading(false);
  };

  // Filtrar usuarios por búsqueda (fuera del JSX)
  let usuariosFiltrados = [];
  if (usuarios && Array.isArray(usuarios)) {
    usuariosFiltrados = usuarios.filter(u => {
      const texto = `${u.nombre} ${u.apellidos} ${u.email}`.toLowerCase();
      return texto.includes(busquedaUsuario.toLowerCase());
    });
  }


  // Eliminar el fetchFichajes automático al montar, solo se llama al pulsar Filtrar


  // Helper para convertir fecha UTC a local Europe/Madrid para input datetime-local
  function toMadridLocalInput(utcDateStr) {
    const utcDate = new Date(utcDateStr);
    // Obtener los componentes en la zona horaria Madrid
    const madrid = new Date(utcDate.toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));
    // Formatear para input datetime-local (YYYY-MM-DDTHH:mm)
    const pad = n => n.toString().padStart(2, '0');
    const yyyy = madrid.getFullYear();
    const MM = pad(madrid.getMonth() + 1);
    const dd = pad(madrid.getDate());
    const hh = pad(madrid.getHours());
    const mm = pad(madrid.getMinutes());
    return `${yyyy}-${MM}-${dd}T${hh}:${mm}`;
  }

  // Helper para convertir fecha local Europe/Madrid a UTC
  function madridInputToUTC(localInput) {
    // localInput: 'YYYY-MM-DDTHH:mm'
    const madridDate = new Date(localInput);
    // Obtener la fecha interpretada como Madrid
    const utcDate = new Date(madridDate.toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));
    return utcDate.toISOString();
  }

  const openModal = (fichaje) => {
    setSelected(fichaje);
    setMotivo('');
    setNuevoTipo(fichaje.tipo);
    setNuevaFecha(toMadridLocalInput(fichaje.fecha));
    setError('');
    setSuccess('');
  };

  const closeModal = () => {
    setSelected(null);
    setMotivo('');
    setNuevoTipo('');
    setNuevaFecha('');
    setError('');
    setSuccess('');
  };


  const handleModificar = async () => {
    if (!motivo || motivo.trim().length < 3) {
      setError('El motivo es obligatorio y debe ser descriptivo.');
      return;
    }
    setLoading(true);
    try {
      const apiUrl = `${API_BASE}/api/fichaje/${selected._id}/modificar`;
      // Convertir la fecha local a UTC antes de enviar
      const fechaUTC = madridInputToUTC(nuevaFecha);
      const res = await axios.put(apiUrl, {
        tipo: nuevoTipo,
        fecha: fechaUTC,
        motivo
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSuccess('Fichaje modificado correctamente');
      await fetchFichajes();
      closeModal();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al modificar');
      // No cerrar el modal si hay error
    } finally {
      setLoading(false);
    }
  };

  if (!usuario?.allowModify) return null;

  return (
    <div className="panel-mod-fichajes" style={{
      margin: '0',
      fontFamily: 'Inter, Roboto, Arial, sans-serif',
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    }}>
      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes shimmer {
          0% { background-position: -1000px 0; }
          100% { background-position: 1000px 0; }
        }
        
        .panel-mod-fichajes {
          animation: slideUp 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .panel-header {
          text-align: center;
          margin-bottom: 24px;
          padding: 20px;
          background: linear-gradient(135deg, rgba(25, 118, 210, 0.08) 0%, rgba(59, 130, 246, 0.08) 100%);
          border-radius: 16px;
          border: 2px solid rgba(25, 118, 210, 0.2);
        }
        
        .panel-title {
          font-size: 1.8rem;
          font-weight: 700;
          color: #1976d2;
          margin: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          flex-wrap: wrap;
        }
        
        .filters-container {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          padding: 20px;
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          margin-bottom: 24px;
          border: 2px solid #e2e8f0;
        }
        
        .filters-grid {
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-bottom: 8px;
        }
        .filters-row {
          display: flex;
          flex-direction: row;
          gap: 8px;
        }
        .filters-row .filter-group {
          flex: 1 1 0;
        }
        
        .filter-group {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        
        .filter-label {
          font-weight: 600;
          color: #1976d2;
          font-size: 0.9rem;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        
        .filter-input {
          width: 100%;
          padding: 12px 16px;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          font-size: 0.95rem;
          font-family: Inter, sans-serif;
          outline: 0;
          background: #f8fafc;
          transition: all 0.3s;
          box-sizing: border-box;
        }
        
        .filter-input:focus {
          border-color: #1976d2;
          background: #fff;
          box-shadow: 0 0 0 4px rgba(25, 118, 210, 0.1);
          transform: scale(1.01);
        }
        
        .users-list {
          max-height: 150px;
          overflow-y: auto;
          background: #fff;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          padding: 0;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          font-size: 0.85em;
        }
        
        .user-checkbox {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 6px;
          padding: 0;
          margin: 0;
          cursor: pointer;
          border-radius: 8px;
          transition: background 0.2s;
          width: 50%;
          justify-content: flex-start;
          font-size: 0.95em;
        }
        .user-checkbox input[type="checkbox"] {
          margin-left: 0;
          margin-right: 0;
          align-self: flex-start;
        }
        
        .user-checkbox:hover {
          background: #f1f5f9;
        }

        .user-checkbox span {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        
        .filter-btn {
          width: 100%;
          padding: 14px 24px;
          border: 3px solid transparent;
          background: linear-gradient(white, white) padding-box,
                      linear-gradient(135deg, #1976d2 0%, #3b82f6 100%) border-box;
          color: #1976d2;
          border-radius: 12px;
          font-weight: 700;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.3s;
          box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }
        
        .filter-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(25, 118, 210, 0.3);
        }
        
        .filter-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        
        .fichajes-container {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          overflow: hidden;
          flex: 1;
          display: flex;
          flex-direction: column;
          border: 2px solid #e2e8f0;
        }
        
        .fichajes-header {
          display: grid;
          grid-template-columns: 2fr 1fr 2fr 1fr 1fr 60px;
          gap: 12px;
          padding: 16px 20px;
          background: linear-gradient(135deg, #1976d2 0%, #3b82f6 100%);
          color: #fff;
          font-weight: 700;
          font-size: 0.9rem;
          flex-shrink: 0;
        }
        
        .fichajes-list {
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
          -webkit-overflow-scrolling: touch;
        }
        
        .fichaje-row {
          display: grid;
          grid-template-columns: 2fr 1fr 2fr 1fr 1fr 60px;
          gap: 12px;
          padding: 16px 40px;
          border-bottom: 1px solid #e2e8f0;
          transition: all 0.2s;
          align-items: center;
        }
        
        .fichaje-row:hover {
          background: linear-gradient(135deg, rgba(25, 118, 210, 0.05) 0%, rgba(59, 130, 246, 0.05) 100%);
        }
        
        .fichaje-usuario {
          font-weight: 600;
          color: #1e293b;
        }
        
        .fichaje-tipo {
          display: inline-block;
          padding: 6px 12px;
          border-radius: 20px;
          font-weight: 700;
          font-size: 0.85rem;
          text-align: center;
        }
        
        .tipo-entrada {
          background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
          color: white;
        }
        
        .tipo-salida {
          background: linear-gradient(135deg, #ef4444 0%, #f87171 100%);
          color: white;
        }
        
        .fichaje-fecha {
          color: #64748b;
          font-size: 0.9rem;
        }
        
        .fichaje-duracion {
          color: #475569;
          font-weight: 600;
        }
        
        .edit-btn {
          background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
          color: white;
          border: none;
          border-radius: 10px;
          padding: 8px 16px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s;
          box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          font-size: 0.9rem;
        }
        
        .edit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
        }
        
        .empty-state {
          text-align: center;
          padding: 60px 20px;
          color: #94a3b8;
          font-size: 1.1rem;
        }
        
        .alert {
          padding: 16px 20px;
          border-radius: 12px;
          margin-bottom: 16px;
          font-weight: 500;
          animation: slideUp 0.3s ease-out;
        }
        
        .alert-error {
          background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
          color: #991b1b;
          border: 2px solid #ef4444;
        }
        
        .alert-success {
          background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
          color: #065f46;
          border: 2px solid #10b981;
        }
        
        .loader {
          border: 4px solid #f3f3f3;
          border-top: 4px solid #1976d2;
          border-radius: 50%;
          width: 48px;
          height: 48px;
          animation: spin 1s linear infinite;
          margin: 40px auto;
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        /* Modal styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(4px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10000;
          padding: 20px;
          animation: fadeIn 0.3s ease-out;
        }
        
        .modal-content {
          background: white;
          border-radius: 20px;
          width: 100%;
          max-width: 500px;
          max-height: 90vh;
          display: flex;
          flex-direction: column;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
          animation: slideUp 0.3s ease-out;
          overflow: hidden;
        }
        
        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 24px;
          background: linear-gradient(135deg, #1976d2 0%, #3b82f6 100%);
          color: white;
        }
        
        .modal-title {
          font-size: 1.4rem;
          font-weight: 700;
          margin: 0;
        }
        
        .modal-close-btn {
          background: rgba(255, 255, 255, 0.2);
          color: white;
          border: none;
          border-radius: 50%;
          width: 36px;
          height: 36px;
          font-size: 24px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          transition: all 0.2s;
        }
        
        .modal-close-btn:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: scale(1.1);
        }
        
        .modal-body {
          padding: 24px;
          overflow-y: auto;
          flex: 1;
        }
        
        .info-card {
          background: linear-gradient(135deg, rgba(25, 118, 210, 0.08) 0%, rgba(59, 130, 246, 0.08) 100%);
          padding: 16px;
          border-radius: 12px;
          margin-bottom: 20px;
          border: 2px solid rgba(25, 118, 210, 0.2);
        }
        
        .info-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 12px;
        }
        
        .info-item {
          font-size: 0.95rem;
          color: #475569;
        }
        
        .info-label {
          font-weight: 700;
          color: #1976d2;
        }
        
        .form-group {
          margin-bottom: 20px;
        }
        
        .form-label {
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 8px;
          display: block;
          font-size: 0.95rem;
        }
        
        .form-input {
          width: 100%;
          padding: 12px 16px;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          font-size: 0.95rem;
          font-family: Inter, sans-serif;
          outline: 0;
          background: #f8fafc;
          transition: all 0.3s;
          box-sizing: border-box;
        }
        
        .form-input:focus {
          border-color: #1976d2;
          background: #fff;
          box-shadow: 0 0 0 4px rgba(25, 118, 210, 0.1);
        }
        
        .form-textarea {
          min-height: 100px;
          resize: vertical;
          font-family: Inter, sans-serif;
        }
        
        .modal-actions {
          display: flex;
          gap: 12px;
          justify-content: flex-end;
          margin-top: 24px;
        }
        
        .btn-primary {
          padding: 12px 32px;
          border: none;
          background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
          color: white;
          border-radius: 12px;
          font-weight: 700;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.3s;
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
        }
        
        .btn-primary:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
        }
        
        .btn-primary:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        
        .btn-secondary {
          padding: 12px 32px;
          border: 2px solid #e2e8f0;
          background: white;
          color: #64748b;
          border-radius: 12px;
          font-weight: 700;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.3s;
        }
        
        .btn-secondary:hover {
          border-color: #cbd5e1;
          background: #f8fafc;
        }
        
        .historico-box {
          margin-top: 20px;
          background: #f8fafc;
          padding: 16px;
          border-radius: 12px;
          border: 2px solid #e2e8f0;
        }
        
        .historico-title {
          font-weight: 700;
          color: #1976d2;
          margin-bottom: 12px;
          font-size: 1rem;
        }
        
        .historico-list {
          max-height: 200px;
          overflow-y: auto;
        }
        
        .historico-item {
          padding: 12px;
          background: white;
          border-radius: 8px;
          margin-bottom: 8px;
          border: 1px solid #e2e8f0;
        }
        
        .historico-fecha {
          color: #64748b;
          font-size: 0.85rem;
        }
        
        .historico-motivo {
          color: #ef4444;
          font-weight: 500;
          margin-top: 4px;
        }
        
        /* Responsive */
        @media (max-width: 768px) {
          .panel-title { font-size: 1.3rem; }
          .filters-container { padding: 14px; }
          .modal-overlay { padding: 0; align-items: flex-end; }
          .modal-content { max-width: 100%; border-radius: 20px 20px 0 0; max-height: 95vh; }
          .modal-actions { flex-direction: column; }
          .btn-primary, .btn-secondary { width: 100%; text-align: center; justify-content: center; }
          .info-grid { grid-template-columns: 1fr; }
          /* En tablet: tabla simplificada */
          .fichajes-header,
          .fichaje-row {
            grid-template-columns: 2fr 1fr 50px;
          }
          .fichajes-header > div:nth-child(3),
          .fichajes-header > div:nth-child(4),
          .fichajes-header > div:nth-child(5),
          .fichaje-row > div:nth-child(3),
          .fichaje-row > div:nth-child(4),
          .fichaje-row > div:nth-child(5) {
            display: none;
          }
        }

        /* Móvil: layout de tarjetas en lugar de tabla */
        @media (max-width: 600px) {
          .panel-header { padding: 14px; margin-bottom: 14px; }
          .panel-title { font-size: 1.1rem; gap: 8px; }
          .filters-container { padding: 12px; margin-bottom: 14px; }
          .filters-row { flex-direction: column; }
          .user-checkbox { width: 100% !important; padding: 6px 8px !important; }
          .fichajes-container { border-radius: 12px; }
          /* Ocultar cabecera de tabla */
          .fichajes-header { display: none; }
          /* Cada fila pasa a ser tarjeta */
          .fichaje-row {
            display: flex !important;
            flex-direction: column !important;
            gap: 8px !important;
            padding: 14px 14px !important;
            margin: 8px 8px !important;
            border-radius: 14px !important;
            border: 2px solid #e2e8f0 !important;
            border-left: 5px solid #1976d2 !important;
          }
          .fichaje-row > div:nth-child(1) { font-size: 1rem; font-weight: 700; order: 1; }
          .fichaje-row > div:nth-child(2) { order: 2; }
          .fichaje-row > div:nth-child(3) { order: 3; font-size: 0.88em; color: #475569; display: block !important; }
          .fichaje-row > div:nth-child(4) { order: 4; font-size: 0.88em; display: block !important; }
          .fichaje-row > div:nth-child(5) { order: 5; display: block !important; }
          .fichaje-row > div:nth-child(6) { order: 6; text-align: left !important; }
          .fichaje-row > div:nth-child(6) .edit-btn { width: 100%; justify-content: center; }
          .modal-overlay { padding: 0; align-items: flex-end; }
          .modal-content { border-radius: 20px 20px 0 0; max-height: 95vh; }
          .modal-header { padding: 16px; }
          .modal-title { font-size: 1.15rem; }
          .modal-body { padding: 14px; }
          .modal-actions { flex-direction: column; margin-top: 16px; }
          .btn-primary, .btn-secondary { width: 100%; justify-content: center; }
        }
      `}</style>
      
      {/* Header */}
      <div className="panel-header">
        <h2 className="panel-title">
          <span style={{ fontSize: '2rem' }}>✏️</span>
          Panel de Modificación de Fichajes
        </h2>
      </div>
      
      {/* Filtros */}
      <div className="filters-container">
        <div className="filters-grid">
          {/* Usuarios: ocupa 100% */}
          <div className="filter-group" style={{width:'100%'}}>
            <label className="filter-label">
              <span>👥</span>
              Usuarios
            </label>
            <input
              type="text"
              placeholder="Buscar usuario..."
              value={busquedaUsuario}
              onChange={e => setBusquedaUsuario(e.target.value)}
              className="filter-input"
            />
            <div className="users-list">
              <label className="user-checkbox">
                <input
                  type="checkbox"
                  checked={usuariosSeleccionados.length === usuariosFiltrados.length && usuariosFiltrados.length > 0}
                  onChange={e => {
                    if (e.target.checked) {
                      setUsuariosSeleccionados(usuariosFiltrados.map(u => u._id));
                    } else {
                      setUsuariosSeleccionados([]);
                    }
                  }}
                />
                <span style={{ fontWeight: 700 }}>Seleccionar todos</span>
              </label>
              {usuariosFiltrados.map(u => (
                <label key={u._id} className="user-checkbox">
                  <input
                    type="checkbox"
                    checked={usuariosSeleccionados.includes(u._id)}
                    onChange={e => {
                      if (e.target.checked) {
                        setUsuariosSeleccionados([...usuariosSeleccionados, u._id]);
                      } else {
                        setUsuariosSeleccionados(usuariosSeleccionados.filter(id => id !== u._id));
                      }
                    }}
                  />
                  <span>{u.nombre} {u.apellidos}</span>
                </label>
              ))}
            </div>
          </div>
          {/* Fechas: en una fila aparte */}
          <div className="filters-row">
            <div className="filter-group">
              <label className="filter-label">
                <span>📅</span>
                Desde
              </label>
              <input
                type="date"
                value={fechaDesde}
                onChange={e => setFechaDesde(e.target.value)}
                className="filter-input"
              />
            </div>
            <div className="filter-group">
              <label className="filter-label">
                <span>📅</span>
                Hasta
              </label>
              <input
                type="date"
                value={fechaHasta}
                onChange={e => setFechaHasta(e.target.value)}
                className="filter-input"
              />
            </div>
          </div>
        </div>
        
        <button onClick={fetchFichajes} className="filter-btn" disabled={loading}>
          <span style={{ fontSize: '1.2rem' }}>🔍</span>
          {loading ? 'Buscando...' : 'Filtrar fichajes'}
        </button>
      </div>
      
      {/* Alerts */}
      {error && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}
      
      {/* Loading */}
      {loading && <div className="loader" />}
      
      {/* Lista de fichajes */}
      {!loading && (
        <div className="fichajes-container">
          <div className="fichajes-header">
            <div>Usuario</div>
            <div>Tipo</div>
            <div>Fecha</div>
            <div>Duración</div>
            <div>Ubicación</div>
            <div style={{ textAlign: 'center' }}>Editar</div>
          </div>
          
          <div className="fichajes-list">
            {fichajes.length === 0 ? (
              <div className="empty-state">
                <div style={{ fontSize: '3rem', marginBottom: '16px' }}>📋</div>
                <div>No hay fichajes para mostrar</div>
                <div style={{ fontSize: '0.9rem', marginTop: '8px' }}>
                  Usa los filtros y pulsa "Filtrar fichajes"
                </div>
              </div>
            ) : (
              fichajes.map((f) => {
                const fueraMargen =
                  (f.ubicacion?.distanciaEmpresa != null && f.ubicacion?.dentroDelMargen === false) ||
                  (!f.ubicacion || f.ubicacion?.error);
                const distM = f.ubicacion?.distanciaEmpresa;
                const distStr = distM != null
                  ? (distM >= 1000 ? `${(distM / 1000).toFixed(2)} km` : `${distM} m`)
                  : null;
                return (
                <div
                  key={f._id}
                  className="fichaje-row"
                  style={fueraMargen ? {
                    background: 'linear-gradient(135deg,#fffbe6 0%,#fff8dc 100%)',
                    borderLeft: '4px solid #fbc02d'
                  } : {}}
                >
                  <div className="fichaje-usuario">
                    {fueraMargen && (
                      <span style={{
                        display:'inline-block',
                        background:'#fbc02d',color:'#7c4a00',
                        fontWeight:800,fontSize:'0.7em',
                        padding:'0.15em 0.45em',borderRadius:6,
                        marginRight:5,verticalAlign:'middle'
                      }}>
                        {(!f.ubicacion || f.ubicacion?.error) ? '📍' : '⚠️'}
                      </span>
                    )}
                    {f.usuario?.nombre} {f.usuario?.apellidos}
                  </div>
                  <div>
                    <span className={`fichaje-tipo ${f.tipo === 'entrada' ? 'tipo-entrada' : 'tipo-salida'}`}>
                      {f.tipo === 'entrada' ? '🟢' : '🔴'} {f.tipo}
                    </span>
                  </div>
                  <div className="fichaje-fecha">
                    {fechaMadrid(f.fecha)}
                  </div>
                  <div className="fichaje-duracion">
                    {f.duracion ? `${Math.floor(f.duracion / 60)}h ${f.duracion % 60}m` : '-'}
                  </div>
                  {/* Columna ubicación */}
                  <div style={{fontSize:'0.82em',lineHeight:1.4}}>
                    {!f.ubicacion || f.ubicacion?.error ? (
                      <span style={{color:'#b45309',fontWeight:700}}>📍 Sin GPS</span>
                    ) : distStr ? (
                      <span style={{color: f.ubicacion.dentroDelMargen ? '#2e7d32' : '#7c4a00', fontWeight:700}}>
                        {f.ubicacion.dentroDelMargen ? '✅' : '⚠️'} {distStr}
                      </span>
                    ) : (
                      <span style={{color:'#94a3b8'}}>—</span>
                    )}
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <button
                      className="edit-btn"
                      onClick={() => openModal(f)}
                      title="Editar fichaje"
                    >
                      <FaEdit /> Editar
                    </button>
                  </div>
                </div>
                );
              })
            )}
          </div>
        </div>
      )}
      
      {/* Modal de edición */}
      {selected && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">✏️ Modificar Fichaje</h3>
              <button className="modal-close-btn" onClick={closeModal} title="Cerrar">
                ×
              </button>
            </div>
            
            <div className="modal-body">
              {/* Información del fichaje */}
              <div className="info-card">
                <div className="info-grid">
                  <div className="info-item">
                    <span className="info-label">Usuario:</span> {selected.usuario?.nombre} {selected.usuario?.apellidos}
                  </div>
                  <div className="info-item">
                    <span className="info-label">Tipo:</span>{' '}
                    <span className={`fichaje-tipo ${selected.tipo === 'entrada' ? 'tipo-entrada' : 'tipo-salida'}`} style={{ display: 'inline-block', marginLeft: '8px' }}>
                      {selected.tipo === 'entrada' ? '🟢' : '🔴'} {selected.tipo}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Fecha original:</span> {new Date(selected.fecha).toLocaleString('es-ES', { timeZone: 'Europe/Madrid' })}
                  </div>
                  <div className="info-item">
                    <span className="info-label">Duración:</span> {selected.duracion ? `${Math.floor(selected.duracion / 60)}h ${selected.duracion % 60}m` : '-'}
                  </div>
                  {/* Ubicación en modal */}
                  {selected.ubicacion && !selected.ubicacion.error && selected.ubicacion.distanciaEmpresa != null && (
                    <div className="info-item" style={{gridColumn:'1/-1'}}>
                      <span className="info-label">Ubicación:</span>{' '}
                      <span style={{
                        fontWeight:700,
                        color: selected.ubicacion.dentroDelMargen ? '#2e7d32' : '#7c4a00',
                        background: selected.ubicacion.dentroDelMargen ? 'rgba(76,175,80,0.10)' : 'rgba(251,192,45,0.18)',
                        border: `1px solid ${selected.ubicacion.dentroDelMargen ? 'rgba(76,175,80,0.3)' : 'rgba(251,192,45,0.5)'}`,
                        borderRadius:8, padding:'0.2em 0.6em', fontSize:'0.95em'
                      }}>
                        {selected.ubicacion.dentroDelMargen ? '✅' : '⚠️'}{' '}
                        {selected.ubicacion.distanciaEmpresa >= 1000
                          ? `${(selected.ubicacion.distanciaEmpresa / 1000).toFixed(2)} km`
                          : `${selected.ubicacion.distanciaEmpresa} m`} de la empresa
                        {!selected.ubicacion.dentroDelMargen && ' · fuera del margen'}
                      </span>
                    </div>
                  )}
                  {(!selected.ubicacion || selected.ubicacion?.error) && (
                    <div className="info-item" style={{gridColumn:'1/-1'}}>
                      <span className="info-label">Ubicación:</span>{' '}
                      <span style={{
                        fontWeight:700,color:'#b45309',
                        background:'rgba(251,192,45,0.15)',
                        border:'1px solid rgba(251,192,45,0.4)',
                        borderRadius:8,padding:'0.2em 0.6em',fontSize:'0.95em'
                      }}>📍 Sin GPS{selected.ubicacion?.error ? `: ${selected.ubicacion.error}` : ''}</span>
                    </div>
                  )}
                </div>
              </div>
              
              {/* Formulario de edición */}
              <div className="form-group">
                <label className="form-label">
                  📅 Nueva fecha y hora
                </label>
                <input
                  type="datetime-local"
                  value={nuevaFecha}
                  onChange={e => setNuevaFecha(e.target.value)}
                  className="form-input"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">
                  📝 Motivo de la modificación <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <textarea
                  value={motivo}
                  onChange={e => setMotivo(e.target.value)}
                  placeholder="Describe detalladamente el motivo de esta modificación..."
                  className="form-input form-textarea"
                />
              </div>
              
              {/* Botones de acción */}
              <div className="modal-actions">
                <button
                  className="btn-secondary"
                  onClick={closeModal}
                >
                  Cancelar
                </button>
                <button
                  className="btn-primary"
                  onClick={handleModificar}
                  disabled={loading || !motivo || motivo.trim().length < 3}
                >
                  {loading ? '⏳ Guardando...' : '💾 Guardar cambios'}
                </button>
              </div>
              
              {/* Error en modal */}
              {error && <div className="alert alert-error" style={{ marginTop: '16px' }}>{error}</div>}
              
              {/* Histórico de modificaciones */}
              {selected.modificaciones && selected.modificaciones.length > 0 && (
                <div className="historico-box">
                  <div className="historico-title">📜 Histórico de modificaciones</div>
                  <div className="historico-list">
                    {selected.modificaciones.map((m, i) => (
                      <div key={i} className="historico-item">
                        <div className="historico-fecha">
                          🕒 {new Date(m.fecha).toLocaleString('es-ES', { timeZone: 'Europe/Madrid' })}
                        </div>
                        <div style={{ color: '#1976d2', fontWeight: 600, fontSize: '0.9rem' }}>
                          👤 {mostrarNombreUsuario(m.usuario, usuarios)}
                        </div>
                        <div className="historico-motivo">
                          💬 {m.motivo}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      
    </div>
  );
}

export default PanelModificacionFichajes;